
<template lang="pug">
.cnmn-validate(
  :class=`{
    'cnmn-validate--error': 0 < errors.length,
    'cnmn-validate--touch': touched,
  }`
)
  slot(
    :errors="errors"
    :hasError="0 < this.errors.length"
    :touch="touch"
    :touched="touched"
  )
</template>

<script>
import {validators} from './validators'
import CnmnField from './cnmn-field'

const errorTextsDefault = {
  require: '必須です',
  email:   '無効なメールアドレスです',
  tel:     '無効な電話番号です',
  post:    '無効な郵便番号です',
}

export default {
  extends: CnmnField,

  props: {
    model:      {type: [String, Object],   required: true},
    rule:       {type: [String, Function], default: ''},
    errorTexts: {type: Object,             default: () => {}},
  },

  computed: {
    errorTextsActual() {
      return {
        ...errorTextsDefault,
        ...this.errorTexts,
      }
    },

    errors() {
      const errors = []
      const pushErrors = results => {
        if(results !== undefined) {
          if(results.constructor.name === 'Array') {
            errors.push(...results)
          }
          else {
            errors.push(results)
          }
        }
      }

      if(this.rule.constructor.name === 'Function') {
        pushErrors(this.rule(this.model))
      }
      else {
        for(const rule of this.rule.split('|')) {
          const [method, args = ''] = rule.split(':')
          if(validators[method] === undefined) {
            console.warn('cnmn-validate: rule not found', method)
          }
          else {
            pushErrors(validators[method](this.model, args.split(',')))
          }
        }
      }

      return errors
    },
  },

  watch: {
    errors(value) {
      this.setFormState(this.stateKey, {errors: value})
    },
  },

  created() {
    this.setFormState(this.stateKey, {errors: this.errors})
  },
}
</script>
